export default "__VITE_ASSET__709a9da0__"